/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */
import type { AppState } from './AppState';

type StateField = keyof AppState;

export function extractAppStateChanges(state: Partial<AppState>, prevState: Partial<AppState>): Partial<AppState> {
  const prevValues: any = {};
  const changes: any = {};

  Object.keys(state).forEach((valueKey) => {
    const changeKey = valueKey as StateField;
    const prevVal = prevState[changeKey];
    const newVal = state[changeKey];

    if (newVal !== prevVal) {
      changes[changeKey] = newVal;
      prevValues[changeKey] = prevVal;
    }
  });

  return changes as Partial<AppState>;
}
